// extracted by mini-css-extract-plugin
module.exports = {"topbar":"style_topbar__3j0mA","logo":"style_logo__39vIh"};